// extracted by mini-css-extract-plugin
export var button = "sectionCards-module--button--66b08";
export var card = "sectionCards-module--card--2e370";
export var cards = "sectionCards-module--cards--8b5c0";
export var richtext = "sectionCards-module--richtext--b1c90";
export var section = "sectionCards-module--section--8e5be";